var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"width-fit-content"},[_c('div',{staticClass:"drop-btn tw-bg-blue-25",on:{"click":_vm.handleClick}},[_c('RoundedUserAvatar',{attrs:{"size":32}}),_c('AppIcon',{staticClass:"tw-fill-blue-gray-600",attrs:{"direction":_vm.arrowDirection,"id":"profile-settings","icon":"arrow"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }